import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Image,
    message, Tooltip
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import {
    PaperClipOutlined,
    QuestionCircleOutlined,
    ExclamationCircleFilled,
    SearchOutlined,
    ReloadOutlined
} from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'
import HtView from '../hetong/view'


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {}, oldcondition: {}, list: [], tableloading: false, selectedRowKeys: [], count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/caigou', ['首页', '采购管理'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, { [name]: dateString })
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, { current: page, pagesize: pagesize })
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Buy/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    tableloading: false,
                    zfjh_react: data.zfjh_react ? data.zfjh_react : [],
                    cglx_react: data.cglx_react ? data.cglx_react : [],
                    count: Number(data.count)
                })
            })
    }

    arrFjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}><a href={item.url} download target={"_blank"}>{item.name}</a></div>
            )
        }
    }

    arrPiclist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Image key={index} src={item.url} width={25} height={25} />
            )
        }
    }

    delSel() {
        let that = this
        fetch('/Buy/allsave', {
            method: "POST", body: JSON.stringify({
                'id': this.state.selectedRowKeys,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Buy/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }

                that.setState({
                    downloading: false
                })
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
            })
    }


    render() {
        const columns = [
            {
                title: '采购类型',
                dataIndex: 'cglx_text',
                key: 'cglx_text',
                width: 130,
            },
            {
                title: '项目名称',
                dataIndex: 'name',
                key: 'name',
                render: (row, record) => {
                    return (<>
                        {row ? <View id={record.id} refresh={this.getdata.bind(this)} title={row} /> : null}
                    </>)
                },
            },
            {
                title: '中标单位',
                dataIndex: 'company',
                key: 'company',
                /*render: (row, record) => {
                    return (<>
                        <View id={record.id} refresh={this.getdata.bind(this)} title={row}/>
                    </>)
                },*/
            }, {
                title: '合同编号',
                dataIndex: 'ref',
                key: 'ref',
                width: 110,
            }, {
                title: '合同签订时间',
                dataIndex: 'qdtime',
                key: 'qdtime',
                width: 120,
                /*render: (row, record) => {
                    return (<>
                        {row ? <View id={record.id} refresh={this.getdata.bind(this)} title={row}/> : null}
                    </>)
                },*/
            }, {
                title: '合同金额',
                dataIndex: 'amount',
                key: 'amount',
                width: 130,
            }, {
                title: '服务期限',
                dataIndex: 'qixian',
                key: 'qixian',
                width: 210,
            }, {
                title: <Space>
                    <span>待支出计划</span>
                    <Tooltip title="临近3个月橙色提醒，临近1个月红色提醒"><QuestionCircleOutlined /></Tooltip>
                </Space>,
                dataIndex: 'plan_status',
                key: 'plan_status',
                width: 160,
                render: (row, record) => {
                    return (<>

                        {record.plan ?
                            <View id={record.id} refresh={this.getdata.bind(this)}
                                title={<Row justify={"start"} align={"stretch"} wrap={false} gutter={10}>
                                    <ExclamationCircleFilled style={{
                                        color: (row == 1 && 'red' || row == 2 && 'orange' || row == 3 && 'rgba(0, 0, 0, 0.85)'),
                                        marginTop: 4,
                                        marginRight: 4
                                    }} />
                                    <div
                                        dangerouslySetInnerHTML={{ __html: record.plan }}
                                        style={{ color: (row == 1 && 'red' || row == 2 && 'orange' || row == 3 && 'rgba(0, 0, 0, 0.85)') }}></div>
                                </Row>} />
                            : null}
                    </>)
                },
            },
            /*{
                title: '我方对接人',
                dataIndex: 'wf_djr',
                key: 'wf_djr',
                width: 120,
            }, {
                title: '对方联系人',
                dataIndex: 'df_lxr',
                key: 'df_lxr',
                width: 120,
            }, {
                title: '联系人电话',
                dataIndex: 'df_phone',
                key: 'df_phone',
                width: 150,
            }*/
            /*, {
                title: '合同附件',
                dataIndex: 'fjlist',
                key: 'fjlist',
                width: 200,
                render: (row, record) => {
                    return (<>
                        {this.arrFjlist(row.filter((item) => item.is_img != 1))}
                        <Image.PreviewGroup
                            preview={{
                                onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                            }}
                        >
                            <Space wrap>
                                {this.arrPiclist(row.filter((item) => item.is_img == 1))}
                            </Space>
                        </Image.PreviewGroup>
                    </>)
                },
            }*/
            , {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                width: 120,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} refresh={this.getdata.bind(this)} />
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('5') ?
                                <Edit refresh={this.getdata.bind(this)} id={record.id} />
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const { tableloading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" align="top" style={{ marginBottom: 15 }}>
                <Space wrap>
                    <Select placeholder="采购类型"
                        style={{ width: 200 }}
                        value={this.state.newcondition.cglx ? this.state.newcondition.cglx : null}
                        onChange={this.onSelChange.bind(this, 'cglx')} allowClear>
                        {this.arrsel(this.state.cglx_react)}
                    </Select>
                    <Input className="input" placeholder="项目名称/中标单位/合同编号"
                        value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                        onChange={this.onChange.bind(this, 'keywords')} autoComplete="off" />
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'time')}
                        style={{ width: 300 }}
                        value={[(this.state.newcondition.time1 ? moment(this.state.newcondition.time1) : null), (this.state.newcondition.time2 ? moment(this.state.newcondition.time2) : null)]}
                        placeholder={['签订时间（开始）', '签订时间（结束）']} />
                    <Select placeholder="待支出计划"
                        style={{ width: 200 }}
                        value={this.state.newcondition.zfjh ? this.state.newcondition.zfjh : null}
                        onChange={this.onSelChange.bind(this, 'zfjh')} allowClear>
                        {this.arrsel(this.state.zfjh_react)}
                    </Select>
                    <Button type="primary" icon={<SearchOutlined />}
                        onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined />} className='huise'
                        onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                <Edit refresh={this.getdata.bind(this)} />
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                // scroll={{x: 2500}}
                style={{ marginBottom: 20 }}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('5') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => this.delSel()}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="primary" danger>删除</Button>
                                </Popconfirm>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('5') ?
                                <Button type="primary"
                                    onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('5') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                    current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                    pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                    total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                    showTotal={total => `共 ${total} 条数据`} />
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname} />
